// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResponseStepPhase } from './ResponseStepPhase';
import {
  ResponseStepPhaseFromJSON,
  ResponseStepPhaseFromJSONTyped,
  ResponseStepPhaseToJSON,
  ResponseStepPhaseToJSONTyped,
} from './ResponseStepPhase';
import type { ResponseResourceProgress } from './ResponseResourceProgress';
import {
  ResponseResourceProgressFromJSON,
  ResponseResourceProgressFromJSONTyped,
  ResponseResourceProgressToJSON,
  ResponseResourceProgressToJSONTyped,
} from './ResponseResourceProgress';

/**
 *
 * @export
 * @interface ResponseStepDetail
 */
export interface ResponseStepDetail {
  /**
   * ActiveClusterRolloutCount is the number of cluster copies whose current
   * step is this one.
   * @type {number}
   * @memberof ResponseStepDetail
   */
  activeClusterRolloutCount?: number;
  /**
   * Approved is true when every cluster copy may run the step, which includes
   * steps that need no approval.
   * @type {boolean}
   * @memberof ResponseStepDetail
   */
  approved?: boolean;
  /**
   *
   * @type {string}
   * @memberof ResponseStepDetail
   */
  approvedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseStepDetail
   */
  completedAt?: string;
  /**
   * CompletedClusterRolloutCount is the number of cluster copies that have
   * completed this step.
   * @type {number}
   * @memberof ResponseStepDetail
   */
  completedClusterRolloutCount?: number;
  /**
   *
   * @type {number}
   * @memberof ResponseStepDetail
   */
  cooldownDurationSeconds?: number;
  /**
   * CooldownEndsAt is the latest end among the cluster copies currently
   * cooling down; omitted when none is.
   * @type {string}
   * @memberof ResponseStepDetail
   */
  cooldownEndsAt?: string;
  /**
   *
   * @type {number}
   * @memberof ResponseStepDetail
   */
  index?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseStepDetail
   */
  name?: string;
  /**
   * Phase is the least-advanced phase of this step across cluster copies.
   * @type {ResponseStepPhase}
   * @memberof ResponseStepDetail
   */
  phase?: ResponseStepPhase;
  /**
   *
   * @type {boolean}
   * @memberof ResponseStepDetail
   */
  requireApproval?: boolean;
  /**
   *
   * @type {Array<ResponseResourceProgress>}
   * @memberof ResponseStepDetail
   */
  resourceProgresses?: Array<ResponseResourceProgress>;
  /**
   * Selector narrows which resources the step selects, in Kubernetes label
   * selector syntax, e.g. "tier=first,env in (prod,staging)".
   * @type {string}
   * @memberof ResponseStepDetail
   */
  selector?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseStepDetail
   */
  startedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseStepDetail
   */
  transferFinishedAt?: string;
  /**
   *
   * @type {string}
   * @memberof ResponseStepDetail
   */
  transferStartedAt?: string;
}

/**
 * Check if a given object implements the ResponseStepDetail interface.
 */
export function instanceOfResponseStepDetail(
  value: object,
): value is ResponseStepDetail {
  return true;
}

export function ResponseStepDetailFromJSON(json: any): ResponseStepDetail {
  return ResponseStepDetailFromJSONTyped(json, false);
}

export function ResponseStepDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseStepDetail {
  if (json == null) {
    return json;
  }
  return {
    activeClusterRolloutCount:
      json['activeClusterRolloutCount'] == null
        ? undefined
        : json['activeClusterRolloutCount'],
    approved: json['approved'] == null ? undefined : json['approved'],
    approvedAt: json['approvedAt'] == null ? undefined : json['approvedAt'],
    completedAt: json['completedAt'] == null ? undefined : json['completedAt'],
    completedClusterRolloutCount:
      json['completedClusterRolloutCount'] == null
        ? undefined
        : json['completedClusterRolloutCount'],
    cooldownDurationSeconds:
      json['cooldownDurationSeconds'] == null
        ? undefined
        : json['cooldownDurationSeconds'],
    cooldownEndsAt:
      json['cooldownEndsAt'] == null ? undefined : json['cooldownEndsAt'],
    index: json['index'] == null ? undefined : json['index'],
    name: json['name'] == null ? undefined : json['name'],
    phase:
      json['phase'] == null
        ? undefined
        : ResponseStepPhaseFromJSON(json['phase']),
    requireApproval:
      json['requireApproval'] == null ? undefined : json['requireApproval'],
    resourceProgresses:
      json['resourceProgresses'] == null
        ? undefined
        : (json['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressFromJSON,
          ),
    selector: json['selector'] == null ? undefined : json['selector'],
    startedAt: json['startedAt'] == null ? undefined : json['startedAt'],
    transferFinishedAt:
      json['transferFinishedAt'] == null
        ? undefined
        : json['transferFinishedAt'],
    transferStartedAt:
      json['transferStartedAt'] == null ? undefined : json['transferStartedAt'],
  };
}

export function ResponseStepDetailToJSON(json: any): ResponseStepDetail {
  return ResponseStepDetailToJSONTyped(json, false);
}

export function ResponseStepDetailToJSONTyped(
  value?: ResponseStepDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    activeClusterRolloutCount: value['activeClusterRolloutCount'],
    approved: value['approved'],
    approvedAt: value['approvedAt'],
    completedAt: value['completedAt'],
    completedClusterRolloutCount: value['completedClusterRolloutCount'],
    cooldownDurationSeconds: value['cooldownDurationSeconds'],
    cooldownEndsAt: value['cooldownEndsAt'],
    index: value['index'],
    name: value['name'],
    phase: ResponseStepPhaseToJSON(value['phase']),
    requireApproval: value['requireApproval'],
    resourceProgresses:
      value['resourceProgresses'] == null
        ? undefined
        : (value['resourceProgresses'] as Array<any>).map(
            ResponseResourceProgressToJSON,
          ),
    selector: value['selector'],
    startedAt: value['startedAt'],
    transferFinishedAt: value['transferFinishedAt'],
    transferStartedAt: value['transferStartedAt'],
  };
}
